import { useMutation } from 'react-query'
import axios from 'axios'

const patchHotSwapWeeks = async data => {
    const response = await axios.patch(
        `${process.env.API_URL}/hotswaps/weeks/capacity`,
        data
    )
    return response.data
}

const usePatchHotSwapWeeks = () => {
    return useMutation(patchHotSwapWeeks, {})
}

export default usePatchHotSwapWeeks
